import React, { FC } from 'react';
import { t } from '../../../../../../utils/helpers';

type PropsType = {
  info: {
    directorName: string;
    directorId: string;
    startTime: string;
    checkIn: string;
    pairing: string;
    timeControl: string;
    entryFee: number;
    description: string;
    extraBonus: string;
  };
};

export const InProgressTournamentInfo: FC<PropsType> = ({
  info,
}: PropsType) => {
  return (
    <div className="progress-additional__info">
      <div className="progress-additional__info-item">
        <div className="progress-additional__info-title">{t('director')}</div>
        <div className="progress-additional__info-description pending-additional__info-name">
          <div className="avatar-overlay">
            <img
              className="progress-additional__img"
              src={`https://www.gamecolony.com/cgi-bin/get_avatar.plx?uid=${info.directorId}&size=2`}
              alt="avatar"
            />
          </div>
          {info.directorName}
        </div>
      </div>

      <div className="progress-additional__info-item">
        <div className="progress-additional__info-title">{t('start_time')}</div>
        <div className="progress-additional__info-description">
          {info.startTime}
        </div>
      </div>

      <div className="progress-additional__info-item">
        <div className="progress-additional__info-title">{t('check_in')}</div>
        <div className="progress-additional__info-description">
          {info.checkIn}
        </div>
      </div>

      <div className="progress-additional__info-item">
        <div className="progress-additional__info-title">{t('pairing')}</div>
        <div className="progress-additional__info-description">
          {info.pairing === '1'
            ? t('single_elim')
            : info.pairing === '2'
            ? t('double_elim')
            : info.pairing === '3'
            ? t('swiss')
            : null}
        </div>
      </div>

      <div className="progress-additional__info-item">
        <div className="progress-additional__info-title">
          {t('time_control')}
        </div>
        <div className="progress-additional__info-description">
          {info.timeControl}
        </div>
      </div>

      <div className="progress-additional__info-item">
        <div className="progress-additional__info-title">{t('entry_fee')}</div>
        <div className="progress-additional__info-description">
          {info.entryFee}
        </div>
      </div>

      <div className="progress-additional__info-item">
        <div className="progress-additional__info-title">
          {t('description')}
        </div>
        <div className="progress-additional__info-description">
          <div className="progress-additional__info-btn-rules">
            <a
              className=""
              target="_blank"
              rel="noreferrer"
              href="https://www.gamecolony.com/single.html"
            >
              {t('see_rules')}
            </a>
          </div>
        </div>
      </div>

      <div className="progress-additional__info-item">
        <div className="progress-additional__info-title"></div>
        <div className="progress-additional__info-description">
          {info.description}
        </div>
      </div>

      {info.extraBonus !== '0.00' ? (
        <div className="progress-additional__info-item">
          <div className="progress-additional__info-title">Extra Bonus</div>
          <div className="progress-additional__info-description">
            {info.extraBonus}
          </div>
        </div>
      ) : null}
    </div>
  );
};
